import React from 'react'
import { OmDropdownMenu } from '@owma/kit'
import chevronDownIcon from 'assets/images/chevron-down-24.svg'
import dateIcon from 'assets/images/todo/property-schedule.svg'
import classNames from 'classnames'
import { RRule } from 'rrule'
import RecurrenceEditor from 'pages/calendar/components/EventEditor/RecurrenceEditor'
import CalendarDatePicker from '../DatePicker'
import useDueDateRecurrence from '../hooks/useDueDateRecurrence'
import styles from './style.module.scss'
import type { DueDateEditData } from './types'

export type { DueDateEditData }

interface DueDateSelectorProps {
  dueDate: Date | null
  onDueDateChange: (date: Date | null, rrule: RRule | null) => void
  disabled?: boolean
  editData: DueDateEditData | null
  onRecurrenceChange: (recurrence: RRule | null) => void
}

const DueDateSelector: React.FC<DueDateSelectorProps> = ({
  dueDate,
  onDueDateChange,
  disabled,
  editData,
  onRecurrenceChange,
}) => {
  const {
    datePickerOpen,
    dueDateDropdownOpen,
    setDueDateDropdownOpen,
    showRecurrenceEditor,
    setShowRecurrenceEditor,
    handleDateChange,
    handleDatePickerClose,
    handleCustomRecurrenceSave,
    createDueDateDropdownMenuItems,
    getDueDateInfoText,
  } = useDueDateRecurrence({
    dueDate,
    onDueDateChange,
    onRecurrenceChange,
    editData,
  })

  const dropdownItems = createDueDateDropdownMenuItems(styles)

  return (
    <div className={styles.dateSelector}>
      <div className={styles.titleIconWrapper}>
        <img src={dateIcon} alt="Date" className={styles.titleIcon} />
      </div>
      <div className={styles.datePickerWrapper}>
        {editData?.recurrenceRule ? (
          <button
            className={styles.dateButton}
            disabled={disabled}
            onClick={() => setShowRecurrenceEditor && setShowRecurrenceEditor(true)}
          >
            <div className={styles.dateDetails}>
              <div className={styles.dateInfo}>
                <span className={styles.dateLabel}>{getDueDateInfoText()}</span>
              </div>
            </div>
            <img src={chevronDownIcon} alt="More" className={styles.chevronIcon} />
          </button>
        ) : (
          <OmDropdownMenu
            menu={{
              items: dropdownItems as any,
            }}
            trigger={['click']}
            open={dueDateDropdownOpen}
            onOpenChange={setDueDateDropdownOpen}
            placement="bottomLeft"
            overlayClassName={classNames('contextMenu', styles.datePickerDropdown)}
            getPopupContainer={() => document.body}
          >
            <button className={styles.dateButton} disabled={disabled}>
              <div className={styles.dateDetails}>
                <div className={styles.dateInfo}>
                  <span className={styles.dateLabel}>{getDueDateInfoText()}</span>
                </div>
              </div>
              <img src={chevronDownIcon} alt="More" className={styles.chevronIcon} />
            </button>
          </OmDropdownMenu>
        )}

        {datePickerOpen && (
          <div className={styles.datePickerOverlay} onClick={handleDatePickerClose}>
            <div onClick={(e) => e.stopPropagation()}>
              <CalendarDatePicker
                value={dueDate}
                onChange={handleDateChange}
                onClose={handleDatePickerClose}
              />
            </div>
          </div>
        )}

        {showRecurrenceEditor && (
          <RecurrenceEditor
            open={showRecurrenceEditor}
            onClose={() => setShowRecurrenceEditor && setShowRecurrenceEditor(false)}
            onSave={handleCustomRecurrenceSave as any}
            startDate={dueDate ? new Date(dueDate) : new Date()}
            options={
              (editData?.recurrenceRule?.origOptions ||
                editData?.recurrenceRule?.options ||
                null) as any
            }
          />
        )}
      </div>
    </div>
  )
}

export default DueDateSelector
